import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useTheme } from '@mui/material/styles'; // Correct import for useTheme
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuIcon from '@mui/icons-material/Menu';
import ProfileHeader from '../../../containers/authentication/ProfileUser/ProfileUser';
import { updateLayout, toggleSidenav, toggleNotifications } from '../../../actions/layout.actions';
import { changeTheme, changeThemeDirection } from '../../../actions/theme.actions';
import cookie from 'react-cookies';
import Api from './../../../util/api';
import AuthApi from './../../../util/authApi';
import { menuItems } from '../../../config';

function setTitle(items, currentPath) {
    for (let i = 0; i < items.length; i += 1) {
        if (items[i].href && items[i].href === currentPath) {
            return items[i].title;
        }

        if (items[i].children) {
            const result = setTitle(items[i].children, currentPath);
            if (result) {
                return result;
            }
        }
    }
    return null;
}

const ContentToolbar = ({
    layout,
    toggleSidenav,
    toggleNotifications,
    updateLayout,
    changeTheme,
    changeThemeDirection,
}) => {
    const [layoutMenuEl, setLayoutMenuEl] = useState(null);
    const [layoutMenuOpen, setLayoutMenuOpen] = useState(false);
    const [themeMenuEl, setThemeMenuEl] = useState(null);
    const [themeMenuOpen, setThemeMenuOpen] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);

    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme(); // Using useTheme hook correctly
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const getNotificationsCnt = async () => {
            const userId = await cookie.load('userId');
            const endPoint = `${Api.notificationsCntUrl}?user_id=${userId}`;
            const { data } = await AuthApi.getDataFromServer(endPoint);
            if (data) {
                setNotificationCount(data.data.count);
            } else {
                setNotificationCount(0);
            }
        };

        getNotificationsCnt();
    }, []);

    const handleOpenLayoutClick = event => {
        setLayoutMenuEl(event.currentTarget);
        setLayoutMenuOpen(true);
    };

    const handleSelectLayoutClick = (event, layout) => {
        updateLayout(layout);
        setLayoutMenuEl(null);
        setLayoutMenuOpen(false);
    };

    const handleCloseLayoutClick = () => {
        setLayoutMenuEl(null);
        setLayoutMenuOpen(false);
    };

    const handleOpenThemeClick = event => {
        setThemeMenuEl(event.currentTarget);
        setThemeMenuOpen(true);
    };

    const handleSelectThemeClick = (event, selectedTheme) => {
        changeTheme(selectedTheme.theme);
        setThemeMenuEl(null);
        setThemeMenuOpen(false);
    };

    const handleCloseThemeClick = () => {
        setThemeMenuEl(null);
        setThemeMenuOpen(false);
    };

    const handleDirectionChange = (event, checked) => {
        changeThemeDirection({
            direction: checked === true ? 'rtl' : 'ltr',
        });
        setThemeMenuEl(null);
        setThemeMenuOpen(false);
    };

    const markNotificationsAsRead = async () => {
        const userId = await cookie.load('userId');
        const endPoint = `${Api.notificationsUrl}?user_id=${userId}`;
        const payload = {
            is_read: true,
        };
        const { data } = await AuthApi.putDataToServer(endPoint, payload);
        if (data) {
            const getNotificationsCnt = async () => {
                const userId = await cookie.load('userId');
                const endPoint = `${Api.notificationsCntUrl}?user_id=${userId}`;
                const { data } = await AuthApi.getDataFromServer(endPoint);
                if (data) {
                    setNotificationCount(data.data.count);
                } else {
                    setNotificationCount(0);
                }
            };

            getNotificationsCnt();
        }
    };

    const showBurgerMenu = isSmallScreen || !layout.sidenavOpen;

    return (
        <Toolbar>
            <IconButton
                color="inherit"
                aria-label="open sidenav"
                style={{ display: showBurgerMenu ? 'block' : 'none' }}
                onClick={toggleSidenav}
            >
                <MenuIcon />
            </IconButton>
            <Typography variant="h6" color="inherit" noWrap className="header-title">
                {setTitle(menuItems, location.pathname) || ''}
            </Typography>
            <span className="portal-flex" />
            <ProfileHeader />
            <IconButton
                color="inherit"
                aria-label="open notifications"
                onClick={() => {
                    markNotificationsAsRead();
                    toggleNotifications();
                }}
            >
                <NotificationsIcon />
                <span className="portal-badge miniCartDrpdwn">{notificationCount}</span>
            </IconButton>
        </Toolbar>
    );
};

function mapStateToProps(state) {
    return {
        layout: {
            sidenavOpen: state.layout.sidenavOpen,
        },
    };
}

ContentToolbar.propTypes = {
    layout: PropTypes.shape({
        sidenavOpen: PropTypes.bool,
    }).isRequired,
    toggleSidenav: PropTypes.func.isRequired,
    toggleNotifications: PropTypes.func.isRequired,
    updateLayout: PropTypes.func.isRequired,
    changeTheme: PropTypes.func.isRequired,
    changeThemeDirection: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
    toggleSidenav,
    toggleNotifications,
    updateLayout,
    changeTheme,
    changeThemeDirection,
})(ContentToolbar);
